import SwitchFormContratanteAsegurado from 'components/Polizas/SwitchFormContratanteAsegurado';
import { IndexColumn } from 'components/Table/Columns';
import useCustomRouter from 'hooks/useCustomRouter';
import useQueryParams from 'hooks/useQueryParams';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import useAsegurados from 'redux/hooks/emision/useAsegurados';
import Beneficiarios from './Beneficiarios';
import ModalAddBeneficiario from './ModalAddBeneficiario';
import ModalAgregarAsegurado from './ModalAgregarAsegurado';
import ModalEliminar from './ModalEliminar';

const Listado = () => {
  const [expandedRows, setExpandedRows] = useState([]);

  const router = useCustomRouter();

  const { idPoliza, codProducto } = useQueryParams();

  const methods = useForm({ mode: 'onChange' });

  const {
    asegurados,
    datosPersonasIngresadas,
    loadingEditarBeneficiarios,
    editarBeneficiarios,
    catalogoBeneficiarios,
    getPorcentajes,
    catalogoForm,
  } = useAsegurados();

  const header = useMemo(
    () => (
      <div className="d-flex flex-row flex-wrap justify-content-between">
        <ModalAgregarAsegurado />

        <h6 className="align-self-center text-right">
          Asegurados ingresados
          {` ${datosPersonasIngresadas?.totalPersonasIngresadas} de ${datosPersonasIngresadas?.totalPersonasPorIngresar}`}
        </h6>
      </div>
    ),
    [datosPersonasIngresadas],
  );

  const editarButton = (rowData) => (
    <Button
      className="p-button-primary p-button-sm btn-block"
      label="Editar"
      onClick={router.goTo(
        `/agregar-asegurado?idPoliza=${idPoliza}&codProducto=${codProducto}&parentesco=${rowData.parentezco}&idAsegurado=${rowData.id}`,
      )}
    />
  );

  const onSubmitAgregarBeneficiario =
    ({ asegurado, handleClose }) =>
    async (formData) => {
      handleClose();
      asegurado.beneficiarios = asegurado?.beneficiarios || [];
      asegurado.beneficiarios.push(formData);

      const porcentajes = getPorcentajes(asegurado.beneficiarios, 0);
      const { min, max } = catalogoBeneficiarios;
      const isValid = await methods.trigger(Object.keys(methods.getValues()));

      if (
        isValid &&
        porcentajes.disponible === 0 &&
        (asegurado.beneficiarios.length >= min ||
          asegurado.beneficiarios.length <= max)
      ) {
        asegurado.estadoIngreso = 'COMPLETADO';
        asegurado.datosCompletos = true;
      } else {
        asegurado.estadoIngreso = 'PENDIENTE';
        asegurado.datosCompletos = false;
      }

      await editarBeneficiarios(asegurado);
    };

  console.log(catalogoForm);

  return (
    <React.Fragment>
      {/* <HiddenForm methods={methods} fields={catalogoForm.validaciones} /> */}
      {catalogoForm?.validaciones && (
        <FormProvider {...methods}>
          <SwitchFormContratanteAsegurado
            formulario="asegurados"
            producto={codProducto}
            campos={catalogoForm.validaciones}
            catalogo={catalogoForm}
            onChanges={{
              onChangeEstado: () => {},
              onChangeMunicipio: () => {},
              onChangeColonia: () => {},
            }}
            loadings={{ loadingMunicipios: false, loadingColonias: false }}
            sources={{
              municipios: catalogoForm.municipios,
              colonias: catalogoForm.colonias,
            }}
          />
        </FormProvider>
      )}
      <DataTable
        className="p-datatable-sm p-datatable-gridlines"
        autoLayout
        header={header}
        emptyMessage="No tiene asegurados ingresados"
        dataKey="id"
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        paginator
        rows={5}
        rowsPerPageOptions={[5, 10, 25, 50]}
        resizableColumns
        rowExpansionTemplate={(rowData) => <Beneficiarios {...rowData} />}
        value={asegurados}
        loading={loadingEditarBeneficiarios}
      >
        <Column
          expander
          style={{ width: '4em' }}
          headerClassName="bg-cyan50 text-coreBlue"
        />
        {IndexColumn({
          headerClassName: 'bg-cyan50 text-coreBlue',
        })}
        <Column
          header="RFC"
          sortable
          field="rfc"
          headerClassName="bg-cyan50 text-coreBlue"
        />
        <Column
          header="Nombre"
          sortable
          field="nombres"
          bodyClassName="text-center"
          headerClassName="bg-cyan50 text-coreBlue"
        />
        <Column
          header="Parentesco"
          sortable
          field="parentezcoLabel"
          bodyClassName="text-center"
          headerClassName="bg-cyan50 text-coreBlue"
        />
        <Column
          header="Estado"
          sortable
          field="estadoIngreso"
          bodyClassName="text-center"
          headerClassName="bg-cyan50 text-coreBlue"
        />

        <Column
          header="Beneficiarios ingresados"
          body={({ beneficiarios }) => beneficiarios?.length || 0}
          style={{ width: '150px' }}
          bodyClassName="text-center"
          headerClassName="bg-cyan50 text-coreBlue"
        />
        <Column
          header="Editar"
          headerClassName="bg-cyan50 text-coreBlue"
          style={{ width: '100px' }}
          body={editarButton}
        />
        <Column
          header="Eliminar"
          style={{ width: '100px' }}
          headerClassName="bg-cyan50 text-coreBlue"
          body={(rowData) => <ModalEliminar {...rowData} />}
        />
        <Column
          header="Beneficiarios"
          style={{ width: '100px' }}
          headerClassName="bg-cyan50 text-coreBlue"
          body={(rowData) => {
            return (
              <ModalAddBeneficiario
                asegurado={rowData}
                onSubmit={onSubmitAgregarBeneficiario}
                beneficiarios={rowData.beneficiarios}
                accion="add"
                onClickButton={() => {
                  const url = `/emision-asegurados?idPoliza=${idPoliza}&codProducto=${codProducto}`;
                  router.replace(`${url}&parentesco=${rowData.parentezco}`);
                  methods.reset(rowData);
                }}
                onClose={() => methods.reset()}
              />
            );
          }}
        />
      </DataTable>
    </React.Fragment>
  );
};

export default Listado;
